// The app's <body> is the scroll container (overflow-x: hidden forces
// overflow-y: auto), so window.scrollTo() is a no-op. Reset every candidate.
export default function scrollToTop() {
  window.scrollTo(0, 0);
  if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}
